export default {
  ADMIN: {
    ACTIVITY: {
      'REAL-TIME': {
        LABEL: 'Actividad en vivo',
        PATH: '/activity/real-time',
      },
    },
    VISIT: {
      DETAILS: {
        LABEL: 'Detalles de visita',
        PATH: '/visit/details',
      }
    }
  }
}